// Simple wrapper to hold page components
//import React from 'react';

const Layout = (props) => props.children;

export default Layout;